export const createError = (message: string, name?: string): Error => {
    const error: any = new Error(message);

    error.name = name || 'Error';
    error.description = message;

    return error;
};
